<template>
  <aside class="page-sidebar event-listing-sidebar">
    <div class="page-sidebar__title">
      Search & Filter
      <button type="button" v-html="assets.arrowDropdown" @click="handleCollapsable"></button>
    </div>

    <div class="page-sidebar-collapsable">
      <div class="event-listing-sidebar__inner">
        <Calendar/>

        <div class="event-listing-sidebar__search-filter">
          <Search/>
          <FilterGroup/>

          <div class="event-calendar-pdf" v-if="assets.pdf">
            <a :href="assets.pdf" class="ignore-ft" target="_blank">
              <img alt="PDF icon" :src="assets.pdfIcon" aria-hidden="true">Abridged<br> Academic Calendar
            </a>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'
import Calendar from './Calendar'
import Search from './Search'
import FilterGroup from './FilterGroup'

export default {
  name: 'Sidebar',

  components: {
    Calendar,
    Search,
    FilterGroup
  },

  computed: {
    ...mapState([
      'assets'
    ])
  },

  methods: {
    handleCollapsable(e) {
      $('.page-sidebar-collapsable').slideToggle('fast', () => {
        e.target.classList.toggle('is-active')
      })
    }
  }
}
</script>
